import React, { useState, useCallback, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { getContext } from '@fiverr-private/fiverr_context';
import { env } from '@fiverr-private/futile';
import { stats } from '@fiverr-private/obs';
import { SafeLazyImport } from '../../common';
import { retry } from '../../../utils/common';
import { BusinessInfoCollectionConsumers } from '../../../constants/acquisition';
import { Breakpoints } from '../../../constants/common';
import { getBusinessPotential } from '../../../services/acquisition';
import { shouldHideStepper, addStepperViews } from './utils';

const METRICS_PREFIX = 'fib_collection_popup';

/** @type {import('types/components/acquisition').BusinessInfoCollectionStepperType} */
const SafeBusinessInfoCollectionStepper = ({ source }) => {
    const isSmallScreen = useMediaQuery({ maxWidth: Breakpoints.Md - 1 });
    const [isVisible, setIsVisible] = useState(false);
    const { userId, url = '' } = getContext();
    const isInBusinessSubDomain = url.includes('business.fiverr');

    const openPopup = useCallback(() => {
        setIsVisible(true);
        addStepperViews();
        stats.count(`${METRICS_PREFIX}`, `${source}.open`);
    }, [setIsVisible, source]);

    useEffect(() => {
        const fetch = async() => {
            try {
                const businessPotential = await getBusinessPotential({ pageName: source });
                if (businessPotential.hasUnknownPotential) {
                    openPopup();
                    stats.count(METRICS_PREFIX, `modal_shown.${source}.true`);
                } else {
                    stats.count(METRICS_PREFIX, `modal_shown.${source}.false`);
                }
            } catch (error) {
                stats.count(METRICS_PREFIX, `show_collection_popup_fib.fetch.fail`);
            }
        }

        if (userId && !isVisible && !shouldHideStepper() && env.browser && !isSmallScreen && !isInBusinessSubDomain) {
            fetch();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isVisible) {
        return null;
    }

    return (
        <SafeLazyImport moduleName="BusinessInfoCollectionStepper"
            source={source}>
            {() =>
                retry({
                    retries: 2,
                    interval: 1500,
                })(() => import(/* webpackChunkName: 'LazyBusinessIdentification' */ './BusinessInfoCollectionStepper'))
            }
        </SafeLazyImport>
    );
};

SafeBusinessInfoCollectionStepper.Consumers = BusinessInfoCollectionConsumers;

export default SafeBusinessInfoCollectionStepper;
